"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraversalSolvableCharacteristicSchema = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
exports.TraversalSolvableCharacteristicSchema = zod_1.z.union([
    BoundaryCharacteristic_1.BoundaryCharacteristicSchema,
    zod_1.z.literal('data'),
]);
//# sourceMappingURL=TraversalSolvableCharacteristic.js.map